import {Component, Input, OnInit} from '@angular/core';
import {ModalController} from '@ionic/angular';
import {AppService} from '../../services/app.service';

@Component({
    selector: 'app-image-modal',
    templateUrl: './image-modal.page.html',
    styleUrls: ['./image-modal.page.scss'],
    standalone: false
})
export class ImageModalPage implements OnInit {
  // Accepts [{image_name: url}] (legacy callers) or [{url, type}]. Type is
  // inferred from the extension so videos play and images pinch/zoom.
  @Input() images: any[] = [];
  items: { url: string; type: 'image' | 'video' }[] = [];
  slideOpts = { zoom: true };

  constructor(private modalCtrl: ModalController, public appService: AppService) {}

  ngOnInit() {
    this.items = (this.images || []).map((im: any) => {
      const url = typeof im === 'string' ? im : (im.image_name || im.url || '');
      const type = /\.(mp4|mov|m4v|webm)(\?|$)/i.test(url) ? 'video' : 'image';
      return { url, type };
    });
  }

  dismissModal() {
    this.modalCtrl.dismiss();
  }
}
